<div class="flex items-center gap-2">

  <input
    type="checkbox"
    [formControl]="control" />

  <label>

    {{ field.label }}

  </label>

</div>